import {Capability} from "../formElementCapability";
import FormElement from "../formElement";
import IFormElementSchema from "./iFormElementSchema";

export default abstract class TemplateElement extends FormElement {
  _elementRestrictions: Array<Array<Capability>>;
  formElementsSchema: Array<IFormElementSchema>;
  restrictionSchema: object = {};
  tempElements: Array<FormElement> = [];

  constructTemplate() {
    this.formElementsSchema.forEach( (elementObj, index) => {
      this.tempElements.push(this.newElementFromSchema(elementObj, this.rootModel, this, index));
    });
    this.tempElements.forEach(e => {
      e.parent.placeInDictionary(e, e.rootName, e.parent);
      e.parent.trackCreationDeletion(e.client_id, null, e.asJson(), e, false);
    });
    this.tempElements.forEach(e => {
      e.parent.hasChanged = true;
    });
    this.tempElements = [];
  }

  newElementFromSchema(elementObj, rootModel, parent: any, order: number, placeAndTrack: boolean = false): FormElement {
    const baseAttrs = {
      sort_order: elementObj.json.sort_order || order,
    };
    const newElement = new FormElement().initialize(rootModel, parent, elementObj.formElementType, baseAttrs);
    newElement.rootModel = rootModel;
    newElement.parent = parent;
    newElement.loadFromJson(Object.assign(elementObj.json, baseAttrs));

    if (elementObj.formElements) {
      elementObj.formElements.forEach( (elObj, ind) => {
        this.tempElements.push(this.newElementFromSchema(elObj, newElement.rootModel, newElement, ind));
      });
    }
    if (placeAndTrack) {
      rootModel.placeInDictionary(newElement, newElement.rootName, parent);
      parent.trackCreationDeletion(newElement.client_id, null, newElement.asJson(), newElement);
    }
    return newElement;
  }

  get isTemplate(): boolean {
    return true;
  }

}
